import { render, staticRenderFns } from "./Mediate.vue?vue&type=template&id=3854e284&scoped=true&"
import script from "./Mediate.vue?vue&type=script&lang=js&"
export * from "./Mediate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3854e284",
  null
  
)

export default component.exports